import { CustomAlert } from '@planning/pages/TallymanV2/Components/CustomAlert'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

interface IProps {
  containersAvailable?: number | null
  containersRequired?: number | null
}

export const NoContainersAlert: FC<IProps> = ({ containersAvailable, containersRequired }) => {
  const { t } = useTranslate()

  return !containersAvailable ? (
    <CustomAlert
      severity='warning'
      message={t(
        'noContainersAvailableToFulfillThisOrderCurrently',
        'No containers available to fulfil this order',
      )}
    />
  ) : (
    <CustomAlert
      severity='warning'
      message={t(
        'amountContainersAvailableToFulfillThisOrder',
        'Only {amount} container(s) available out of {total} for this order',
        { amount: containersAvailable, total: containersRequired },
      )}
    />
  )
}
